import { render, staticRenderFns } from "./timeComponent.vue?vue&type=template&id=1f5e00b4&scoped=true&"
import script from "./timeComponent.vue?vue&type=script&lang=js&"
export * from "./timeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5e00b4",
  null
  
)

export default component.exports